module.exports = __webpack_public_path__ + "static/assets/9547e6b188122ecf79ba8e164a19a909.svg";